import { Col, Row } from '@advanza/grid'
import { Button, Divider } from '@advanza/ui'
import { addCbr, saveCbr } from 'actions/providers'
import { useToast } from 'components/misc/Toaster'
import LoadBoxWrapper from 'components/ui/LoadBoxWrapper'
import { useChangeEntity } from 'hooks/entityHooks'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import React, { useEffect } from 'react'

const FIELDS = {
    pass_perc: {
        type: 'int',
        placeholder: 'Examination %',
        max: 100,
        fallback: null,
        validator: (val) => !val || (0 <= val && val <= 100),
    },
    num_exams: {
        type: 'int',
        placeholder: 'Examination #',
        fallback: null,
        validator: (val) => !val || 0 <= val,
    },
    url: {
        type: 'string',
        placeholder: 'URL',
        fallback: null,
        validator: (val) => !val || /^https:\/\/www\.cbr\.nl\/\S+$/.test(val),
        defaultErrorMsg: 'Has to start with https://www.cbr.nl/',
    },
}

const Cbr = ({ providerId }) => {
    const dispatch = useAppDispatch()
    const { addToast } = useToast()
    const { providers = {} } = useAppSelector((state) => state.providers.entities)
    const provider = providers[providerId]
    const {
        entity: cbr = {},
        onSaveEntity,
        renderInput,
    } = useChangeEntity(
        {
            store: 'providers',
            name: 'cbrs',
            entityId: provider && provider.cbr,
            saveFunc: saveCbr,
        },
        FIELDS,
    )

    const onSave = () =>
        onSaveEntity().then(
            () => addToast({ green: true, msg: 'Examination saved' }),
            (response) => addToast({ msg: JSON.stringify(response) || 'Error' }),
        )

    useEffect(() => {
        if (provider) {
            dispatch(addCbr(provider.service_provider_id))
        }
    }, [dispatch, provider])

    return (
        <LoadBoxWrapper isLoading={!provider || !provider.cbr}>
            <Row>
                <Col x>{renderInput('pass_perc')}</Col>
                <Col x>{renderInput('num_exams')}</Col>
            </Row>
            <Divider m />
            <Row>
                <Col x>{renderInput('url')}</Col>
            </Row>
            <Divider m />
            <Row end="xs">
                <Col x>
                    <Button disabled={!cbr._isTouched || cbr._saving} onClick={onSave}>
                        {cbr._saving ? '..saving' : 'Save'}
                    </Button>
                </Col>
            </Row>
        </LoadBoxWrapper>
    )
}

export default Cbr
